export default __webpack_public_path__ + "static/media/arrow-up-right-from-square.cad3b50d.svg";